import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "../components/AppShell";
import ProtectedRoute from "../components/ProtectedRoute";
import LoginPage from "../pages/LoginPage";
import DashboardHome from "../pages/DashboardHome";
import RidesPage from "../pages/RidesPage";
import PassengersPage from "../pages/PassengersPage";
import DriversPage from "../pages/DriversPage";
import PricingPage from "../pages/PricingPage";
import LiveMapPage from "../pages/LiveMapPage";
import TripReportsPage from "../pages/TripReportsPage";
import WithdrawalRevenuePage from "../pages/WithdrawalRevenuePage";
import CouponsPage from "../pages/CouponsPage";

export default function App() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <DashboardHome />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/rides"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <RidesPage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/map"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <LiveMapPage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/reports"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <TripReportsPage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/withdrawals"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <WithdrawalRevenuePage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/coupons"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <CouponsPage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/passengers"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <PassengersPage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/drivers"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <DriversPage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/settings"
                element={
                    <ProtectedRoute>
                        <AppShell>
                            <PricingPage />
                        </AppShell>
                    </ProtectedRoute>
                }
            />
            <Route path="/pricing" element={<Navigate to="/settings" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
